import HomeWork from 'homework/model/homework'

const state = {
  activeHomeWork: new HomeWork({}), // 发布的作业
  historyWorks: [],
  classList: [],
  stuHomeWork: {}, // 学生的当前的作业 --已编写的
  peerReviewHomeworkList: [], // 评价的作业列表
  peerTasks: [], // 评价任务
  marks: [], // 批注文字
  attach: {}, // 要显示的附件详情
  isLoading: false,
  courseRole: 3 // 1管理员2教师3助教
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js